/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S14_P1Inputs */

const tr_iade_iptal_s14_p1 = /** @type {(inputs: Iade_Iptal_S14_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Politika'da yapılacak esaslı değişiklikler en az 30 gün önceden Abone'ye e-posta ve Platform içi bildirim ile duyurulur. Aktif Aboneler bakımından, eski Politika onların mevcut abonelik dönemi sonuna kadar geçerli olmaya devam eder; yeni Politika yenileme veya yeni satın alma anında yürürlüğe girer.`)
};

const en_iade_iptal_s14_p1 = /** @type {(inputs: Iade_Iptal_S14_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material amendments to this Policy are announced to the Subscriber at least 30 days in advance by email and by in-platform notice. For active Subscribers, the old Policy continues to apply until the end of their current subscription period; the new Policy takes effect at the moment of renewal or of a new purchase.`)
};

const de_iade_iptal_s14_p1 = /** @type {(inputs: Iade_Iptal_S14_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wesentliche Änderungen dieser Richtlinie werden dem Abonnenten mindestens 30 Tage im Voraus per E-Mail und per Mitteilung in der Plattform bekannt gegeben. Für aktive Abonnenten gilt die alte Richtlinie bis zum Ende ihres laufenden Abonnementzeitraums weiter; die neue Richtlinie tritt im Zeitpunkt der Verlängerung oder eines neuen Kaufs in Kraft.`)
};

const ru_iade_iptal_s14_p1 = /** @type {(inputs: Iade_Iptal_S14_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О существенных изменениях настоящей Политики Абонент уведомляется не менее чем за 30 дней по электронной почте и уведомлением в Платформе. Для действующих Абонентов прежняя Политика продолжает действовать до конца их текущего периода подписки; новая Политика вступает в силу в момент продления или новой покупки.`)
};

/**
* | output |
* | --- |
* | "Material amendments to this Policy are announced to the Subscriber at least 30 days in advance by email and by in-platform notice. For active Subscribers, th..." |
*
* @param {Iade_Iptal_S14_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s14_p1 = /** @type {((inputs?: Iade_Iptal_S14_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S14_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s14_p1(inputs)
	if (locale === "de") return de_iade_iptal_s14_p1(inputs)
	if (locale === "ru") return ru_iade_iptal_s14_p1(inputs)
	return tr_iade_iptal_s14_p1(inputs)
});